<template>
  <v-app id="inspire">
    <v-row
      align="center"
      justify="center"
      rows="6"
    >
      <v-col
        cols="12"
        sm="8"
        md="4"
      >
        <div id="show-results">
          <h1 :class="`d-flex justify-center`">Here are your results</h1>
          <h3 @click="performAnotherSearch()"
          :class="`d-flex justify-center`"
          style="cursor: pointer;
          text-decoration: underline;
          margin: 40px 0 0;
          color: rgb(91, 184, 190);">
            Perform Another Search</h3>
          <br>
          <br>
          <div v-for="(book, index) in booksFound" :key="index" :delay="100">
            <v-h2 :class="`d-flex justify-center`" @click="openNewTab(book.url)"
            style="text-align: center;
            cursor: pointer;
            text-decoration: underline;">{{ book.name }}</v-h2>
            <article :class="`d-flex justify-center`">{{ book.dealQuality }}</article>
            <article :class="`d-flex justify-center`">Current Price: ${{ book.value }}</article>
            <v-spacer></v-spacer>
            <v-img :src=book.image @click="openNewTab(book.url)"
              :class="`d-flex justify-center`"
              max-height="300"
              contain
              style="cursor: pointer;"></v-img>
            <br>
            <br>
            <v-divider :inset="inset"></v-divider>
            <br>
          </div>
          <h3 @click="performAnotherSearch()"
          style="cursor: pointer;
          text-decoration: underline;
          margin: 40px 0 0;
          color: rgb(91, 184, 190);"
          :class="`d-flex justify-center`">
            Perform Another Search</h3>
          <br>
          <br>
          <br>
        </div>
      </v-col>
    </v-row>
  </v-app>
</template>

<script>

export default {
  name: 'ResultsPage',
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    booksFound() {
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.loading = true;
      const result = this.$store.state.searchResults;
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.loading = false;
      return result;
    },
  },
  methods: {
    openNewTab(url) {
      window.open(`http://rover.ebay.com/rover/1/711-53200-19255-0/1?ff3=4&pub=5575611315&toolid=10001&campid=5338722306&customid=&mpre=${url}`);
    },
    performAnotherSearch() {
      this.$router.push('/');
    },
  },
};
</script>

<style scoped>
